module.exports = __webpack_public_path__ + "assets/gray-pooledUser-e8b978.svg";